import { FilloutEnquiry } from '../components/FilloutEnquiry'
import { PageHero } from '../components/PageHero'
import { PageMeta } from '../components/PageMeta'

const nextSteps = [
  {
    title: 'We read the context',
    body: 'We review what you tell us to understand the outcome and the environment.',
  },
  {
    title: 'We confirm fit and scope',
    body: 'We establish whether Informat is a suitable fit and what needs to be clarified.',
  },
  {
    title: 'We agree a useful next step',
    body: 'We propose a practical next action appropriate to the situation.',
  },
]

export function ContactPage() {
  return (
    <main id="main-content" className="route-page">
      <PageMeta
        title="Discuss a project"
        description="Tell Informat what needs to work better across business technology, systems, networks, cloud or complex Microsoft environments."
      />
      <PageHero
        className="contact-page-hero"
        title={
          <>
            Tell us what needs to work better.
            <span className="text-cursor" aria-hidden="true" />
          </>
        }
        body="Whether you are putting foundations in place, improving business systems or working through a complex environment, start with the outcome you need."
      />
      <section className="contact-workspace section-dark">
        <FilloutEnquiry />
      </section>
      <section className="what-next section-light" aria-labelledby="what-next-title">
        <h2 id="what-next-title">What happens next</h2>
        <div>
          {nextSteps.map((step, index) => (
            <article key={step.title} data-reveal>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </div>
            </article>
          ))}
        </div>
        <blockquote>Technology, quietly mastered.</blockquote>
      </section>
    </main>
  )
}
